import {
  Component,
  OnInit,
  AfterViewInit,
  Inject,
  Output,
  EventEmitter,
} from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { DOCUMENT } from "@angular/common";
import { DbService } from "../core/services/db.service";
import { AuthService } from "../core/services/auth.service";
import { AlertService } from "../core/services/alert.service";
import { Observable, map } from "rxjs";
import { Notifications } from "../models/notifications";
import * as dayjs from "dayjs";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.scss"],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;
  alarmSwitch = true;
  userRole: string;

  alarms;
  //TODO 사이드 메뉴 리스트 넣기
  allMenus = [
    {
      label: "대시보드",
      icon: "bx-home",
      link: "/dashboard",
      roles: ["ADMIN", "PM"]
    },
    {
      label: "회원 관리",
      icon: "bx-user",
      roles: ["ADMIN"],
      subItems: [
        {
          label: "일반 회원",
          link: "/user-list",
        },
        {
          label: "유지보수 담당자 등록",
          link: "/manager-management",
        },
      ],
    },
    //TODO 유지보수
    {
      label: "유지보수 관리",
      icon: "bx-list-ul",
      roles: ["ADMIN", "PM"],
      subItems: [
        {
          label: "유지보수 발전소 등록",
          link: "/solar-power-plant-management",
        },
        {
          label: "유지보수 조치 결과",
          link: "/maintenance-management",
        },
      ],
    },
    {
      label: "발전소 진행 현황",
      icon: "bx-list-ul",
      link: "/solar-power-plant-status",
      roles: ["ADMIN", "PM"]
    },
    {
      label: "무료견적서비스 \n 의뢰 관리",
      icon: "bx-list-ul",
      roles: ["ADMIN"],
      subItems: [
        {
          label: "문의 관리",
          link: "/question-management",
        },
        {
          label: "견적예상금액 관리",
          link: "/amount-management",
        },
      ],
    },
    {
      label: "조회수 관리",
      icon: "bx-list-ul",
      link: "/view-management",
      roles: ["ADMIN"]
    },
    {
      label: "데이터 관리",
      icon: "bx-list-ul",
      roles: ["ADMIN"],
      subItems: [
        {
          label: "에디터 관리 - 홈메뉴1",
          link: "/editor-home1/developmentConsulting",
        },
        {
          label: "에디터 관리 - 홈상세",
          link: "/editor-home-detail/editorModuleClean",
        },
        {
          label: "링크 관리",
          link: "/link-management/homeLink",
        },
        {
          label: "이미지 관리",
          link: "/image-management",
        },
        {
          label: "동영상 관리",
          link: "/video-management/home",
        },
        {
          label: "파일 다운로드 관리",
          link: "/file-download-management/home",
        },
      ],
    },
    {
      label: "서비스/정보관리",
      icon: "bx-note",
      roles: ["ADMIN"],
      subItems: [
        {
          label: "팝업 관리",
          link: "/pop-up-management",
        },
        {
          label: "공지사항",
          link: "/notice",
        },
        {
          label: "FAQ",
          link: "/faq",
        },
        {
          label: "1:1 문의",
          link: "/inquiry",
        },
        {
          label: "개인정보/서비스 이용약관",
          link: "/terms",
        },
      ],
    },
  ];

  menu = [];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService,
    private auth: AuthService,
    private alertService: AlertService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    // 사용자 역할 가져오기
    this.userRole = localStorage.getItem("role");
    
    // 역할에 따른 메뉴 필터링
    this.menu = this.allMenus.filter(item => 
      item.roles && item.roles.includes(this.userRole)
    );

    //사이드바 정의
    document.body.setAttribute("data-sidebar", "dark");
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.getNotifications();
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle("right-bar-enabled");
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle("sidebar-enable");
    document.body.classList.toggle("vertical-collpsed");

    if (window.screen.width <= 768) {
      document.body.classList.remove("vertical-collpsed");
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle("mm-show");
  }

  scrollable() {
    document.body.setAttribute("data-layout-scrollable", "true");
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.auth.logoutUser().then(() => {
      this.router.navigate(["/account/login"]);
    });
  }

  public hide() {
    document.body.classList.remove("right-bar-enabled");
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>(".active");
    if (activeTag) {
      activeTag.classList.remove("active");
    }
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach((ele) => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(
              `.atag${mi}${index}`
            );

            aTag.classList.add("active");
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add("active");
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }

  // 알람 내역 데이터
  notifications$: Observable<Notifications> | any;
  unReadLength: number = 0;
  getNotifications() {
    this.notifications$ = this.db
      .collection$(`notifications`, (ref) =>
        ref.where("uuid", "==", "admin").orderBy("dateCreated", "desc")
      )
      .pipe(
        map((notifications: Notifications[] | any) => {
          this.alarms = notifications;
          this.unReadLength = notifications.filter(
            (notification) => !notification.readSwitch
          ).length;
          return notifications;
        })
      );
  }

  async read() {
    this.alarmSwitch = false;

    // 'admin' uuid를 가진 모든 알림을 찾아서 읽음으로 표시
    // const adminNotifications = await this.db.toCollection$(`notifications`, ref => ref.where('uuid', '==', 'admin'));
    // 찾은 알림들을 모두 읽음으로 표시
    for (const notification of this.alarms) {
      this.db.updateAt(`notifications/${notification.id}`, {
        readSwitch: true,
      });
    }
  }

  // 알림내역 시간 표시
  displayedAt(dateCreated: string) {
    const milliSeconds = new Date().getTime() - dayjs(dateCreated).valueOf();
    const seconds = milliSeconds / 1000;

    if (seconds < 60) {
      return `방금 전`;
    }
    const minutes = seconds / 60;
    if (minutes < 60) {
      return `${Math.floor(minutes)}분 전`;
    }
    const hours = minutes / 60;
    if (hours < 24) {
      return `${Math.floor(hours)}시간 전`;
    }
    const days = hours / 24;
    if (days < 30) {
      return `${Math.floor(days)}일 전`;
    }
    const months = days / 30;
    if (months < 12) {
      return `${Math.floor(months)}개월 전`;
    }

    return dayjs(dateCreated).format("YY.MM.DD");
  }

  // 알림 [상세]
  async alarm(item: Notifications) {
    await this.db.updateAt(`notifications/${item.id}`, {
      readSwitch: true,
    });
    // 해당 페이지로 이동
    if (item?.url) {
      this.router.navigate([`${item.url}`]);
    }
  }

  // 알림 [전체삭제]
  async alarmDelete() {
    const ok = await this.alertService.warningConfirm(
      "전체 삭제하시겠습니까?",
      "확인"
    );

    if (ok) {
      this.notifications$.forEach((notifications: Notifications[]) => {
        notifications.forEach((notification) => {
          this.db.delete(`notifications/${notification.id}`);
        });
      });
    }
  }

  //클릭시 active class
  // _activateMenuDropdown() {
  //   this._removeAllClass('mm-active');
  //   this._removeAllClass('mm-show');
  //   const links = document.getElementsByClassName('side-nav-link-ref');
  //   let menuItemEl = null;
  //   // tslint:disable-next-line: prefer-for-of
  //   const paths = [];
  //   for (let i = 0; i < links.length; i++) {
  //     paths.push(links[i]['pathname']);
  //   }
  //   var itemIndex = paths.indexOf(window.location.pathname);
  //   if (itemIndex === -1) {
  //     const strIndex = window.location.pathname.lastIndexOf('/');
  //     const item = window.location.pathname.substr(0, strIndex).toString();
  //     menuItemEl = links[paths.indexOf(item)];
  //   } else {
  //     menuItemEl = links[itemIndex];
  //   }
  //   if (menuItemEl) {
  //     menuItemEl.classList.add('active');
  //     const parentEl = menuItemEl.parentElement;
  //     if (parentEl) {
  //       parentEl.classList.add('mm-active');
  //       const parent2El = parentEl.parentElement.closest('ul');
  //       if (parent2El && parent2El.id !== 'side-menu') {
  //         parent2El.classList.add('mm-show');
  //         const parent3El = parent2El.parentElement;
  //         if (parent3El && parent3El.id !== 'side-menu') {
  //           parent3El.classList.add('mm-active');
  //           const childAnchor = parent3El.querySelector('.has-arrow');
  //           const childDropdown = parent3El.querySelector('.has-dropdown');
  //           if (childAnchor) {
  //             childAnchor.classList.add('mm-active');
  //           }
  //           if (childDropdown) {
  //             childDropdown.classList.add('mm-active');
  //           }
  //           const parent4El = parent3El.parentElement;
  //           if (parent4El && parent4El.id !== 'side-menu') {
  //             parent4El.classList.add('mm-show');
  //             const parent5El = parent4El.parentElement;
  //             if (parent5El && parent5El.id !== 'side-menu') {
  //               parent5El.classList.add('mm-active');
  //               const childanchor = parent5El.querySelector('.is-parent');
  //               if (childanchor && parent5El.id !== 'side-menu') {
  //                 childanchor.classList.add('mm-active');
  //               }
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }
  // }

  // // 메뉴 클릭시 다른주소 remove class
  // _removeAllClass(className) {
  //   const els = document.getElementsByClassName(className);
  //   while (els[0]) {
  //     els[0].classList.remove(className);
  //   }
  // }
}
